import Prism from "prismjs";
import "prismjs/plugins/line-numbers/prism-line-numbers";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
import "prismjs/themes/prism-tomorrow.css";
import React, { useEffect, useState } from "react";

const CodeBlock = ({ children }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      Prism.highlightAll();
    }
  }, [mounted]);

  return (
    <div style={{ padding: "4rem 0 4rem 0" }}>
      {mounted && (
        <pre>
          <code className="line-numbers language-javascript">{children}</code>
        </pre>
      )}
    </div>
  );
};

export default CodeBlock;
